import __vue_component__ from '../common/Popup.vue.js';

//
var script = {
  components: {
    Popup: __vue_component__
  },
  props: {
    boundariesElement: {
      type: [String, HTMLElement, Function],
      default: 'viewport'
    },
    placement: {
      type: String,
      default: 'right-top'
    },
    offset: {
      type: String,
      default: '8,8'
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: true
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    positionFixed: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      open: false
    };
  },

  watch: {
    open(value) {
      if (value) {
        document.addEventListener('click', this.onOutsideClick);
        document.addEventListener('keydown', this.onKeyDown);
        this.$emit('open');
      } else {
        document.removeEventListener('click', this.onOutsideClick);
        document.removeEventListener('keydown', this.onKeyDown);
        this.$emit('close');
      }
    }

  },

  beforeDestroy() {
    document.removeEventListener('click', this.onOutsideClick);
  },

  methods: {
    onTriggerClick() {
      this.open = !this.open;
    },

    onOutsideClick(event) {
      if (this.$refs['dialog-container'].contains(event.target)) return;

      if (this.closeOnOutsideClick) {
        this.open = false;
      }
    },

    onKeyDown(event) {
      if (event.keyCode === 27 && this.closeOnEsc) {
        this.open = false;
      }
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/InlineDialog/InlineDialog.vue_rollup-plugin-vue=script.js